/* tslint:disable */
export class ApiKeyModel {
  public api_key: string = ''
  public access_right: number = 1
}

export class IPAddressModel {
  public ip_address: string = ''
  public active: boolean = true
}

export class ManageFeaturesModel {
  public stamp_rally: boolean = false
  public work_recorder: boolean = false
  public ip_camera: boolean = false
  public geofence: boolean = false
  public indoor_map: boolean = true
  public outdoor_map: boolean = true
  public link: boolean = false
}

export default class UnitModel {
  public _id: string
  public name: string
  public customer_name: string
  public address: string
  public timezone: string
  public token: string
  public db_name: string
  public logo: string
  public domains: string[]
  public api_keys: ApiKeyModel[]
  public ip_whitelist: IPAddressModel[]
  public is_active: boolean
  public created_at: Date
  public updated_at: Date
  public threshold: number
  public manage_features: ManageFeaturesModel

  constructor() {
    this._id = ''
    this.name = ''
    this.customer_name = ''
    this.address = ''
    this.token = ''
    this.db_name = ''
    this.logo = ''
    this.timezone = 'Asia/Tokyo'
    this.domains = ['']
    this.api_keys = []
    this.ip_whitelist = []
    this.is_active = true
    this.created_at = new Date()
    this.updated_at = new Date()
    this.threshold = 10
    this.manage_features = new ManageFeaturesModel()
  }
}
